import { Question, Section } from '@playbooks/core/src/interfaces/ActionCard'

import { QUESTION_FILE_UPLOAD_STORE_NAME, getFileQuestionsDb } from './dbService'
import { QuestionFile } from '../types'

export class WebPlayQuestionFileUploadStorageService {
  playbookId: string
  db: IDBDatabase | null = null

  constructor(playbookId: string) {
    this.playbookId = playbookId
  }

  async getDbLazy() {
    if (!this.db) {
      this.db = await getFileQuestionsDb(this.playbookId)
    }
    return this.db
  }

  async saveFile(question: Question, currentHeader: Section, file: File) {
    const db = await this.getDbLazy()
    return new Promise<number>((resolve, reject) => {
      const header = {
        id: currentHeader.id,
        name: currentHeader.name,
      }
      const fileItem = { questionId: question.id, header: header, file: file }

      const request = db
        .transaction(QUESTION_FILE_UPLOAD_STORE_NAME, 'readwrite')
        .objectStore(QUESTION_FILE_UPLOAD_STORE_NAME)
        .add(fileItem)

      request.onsuccess = function (this: IDBRequest) {
        resolve(this.result as number)
      }

      request.onerror = function () {
        reject(this.error)
      }
    })
  }

  async deleteFile(fileItem: { id: number }) {
    const db = await this.getDbLazy()
    return new Promise<void>((resolve, reject) => {
      const request = db
        .transaction(QUESTION_FILE_UPLOAD_STORE_NAME, 'readwrite')
        .objectStore(QUESTION_FILE_UPLOAD_STORE_NAME)
        .delete(fileItem.id)

      request.onsuccess = function () {
        resolve()
      }

      request.onerror = function () {
        reject(this.error)
      }
    })
  }

  async getAll(question?: Question) {
    const db = await this.getDbLazy()
    return new Promise<QuestionFile[]>((resolve, reject) => {
      const fileItems: QuestionFile[] = []
      const request = db
        .transaction(QUESTION_FILE_UPLOAD_STORE_NAME, 'readonly')
        .objectStore(QUESTION_FILE_UPLOAD_STORE_NAME)
        .openCursor()

      request.onsuccess = function () {
        const cursor = this.result

        if (cursor) {
          if (!question || cursor.value.questionId === question.id) {
            fileItems.push(cursor.value)
          }
          cursor.continue()
        } else {
          resolve(fileItems)
        }
      }

      request.onerror = function () {
        reject(this.error)
      }
    })
  }
}
